import SActivityHeader from './style.module.scss';
import { Link } from 'react-scroll';
import NextLink from 'next/link';
import { WebPNextImage } from '@/components/WebPImage';
import { useEffect, useRef } from 'react';

const logo = {
  dark: '/img/logo-light-row.webp',
  light: '/img/logo.webp',
};

const ActivityHeader = ({
  nav,
  theme = 'dark',
}: {
  nav: string[];
  theme?: 'light' | 'dark';
}) => {
  const headerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const listener = () => {
      const element = headerRef.current;
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > 0) {
        element.classList.add(SActivityHeader['scrolled']);
      } else {
        element.classList.remove(SActivityHeader['scrolled']);
      }
    };
    window.addEventListener('scroll', listener);
    return () => {
      window.removeEventListener('scroll', listener);
    };
  }, []);

  return (
    <div
      className={`${SActivityHeader['header']} ${SActivityHeader[theme]}`}
      ref={headerRef}
    >
      <NextLink href={'/'}>
        <div className={SActivityHeader['logo']}>
          <WebPNextImage src={logo[theme]} alt="logo" layout="fill" />
        </div>
      </NextLink>
      <div className={SActivityHeader['nav']}>
        {nav.map((item, index) => [
          <Link
            className={SActivityHeader['nav-item']}
            activeClass={SActivityHeader['nav-item-active']}
            to={item}
            spy={true}
            smooth="easeInOutQuart"
            duration={800}
            isDynamic={true}
            delay={0}
            key={index}
          >
            {item}
          </Link>,
        ])}
      </div>
    </div>
  );
};

export default ActivityHeader;
